import { AxiosResponse } from 'axios';
import { BASE_URL } from './../config/api';
import { DeliveryCompany } from 'src/admin-entity/interface/delivery/delivery-company.interface';
import client from './client';

export const getDeliveryCompanies = (): Promise<AxiosResponse<DeliveryCompany[]>> =>
    client.get(`${BASE_URL}/v1/admin/delivery-companies?page=0&take=100`);

export const getDetailDeliveryCompany = (id: string): Promise<AxiosResponse<DeliveryCompany>> =>
    client.get(`${BASE_URL}/v1/admin/delivery-companies/${id}`);

export const deleteDeliveryCompany = (id: string): Promise<AxiosResponse<boolean>> =>
    client.delete(`${BASE_URL}/v1/admin/delivery-companies/${id}`);

export const updateDeliveryCompany = (deliveryCompany: DeliveryCompany): Promise<AxiosResponse<boolean>> =>
    client.put(`${BASE_URL}/v1/admin/delivery-companies/${deliveryCompany.id}`, deliveryCompany);

export const createDeliveryCompany = (deliveryCompany: DeliveryCompany): Promise<AxiosResponse<boolean>> =>
    client.post(`${BASE_URL}/v1/admin/delivery-companies`, deliveryCompany);
